const AGB_de = `
# Allgemeine Geschäftsbedingungen (AGB)

## 1. Geltungsbereich  
Diese Webseite wird von **Esther Ratsch und Jörg Schultz GbR** bereitgestellt und richtet sich an alle interessierten Nutzerinnen und Nutzer.

## 2. Leistungsbeschreibung  
Die Webseite stellt **kostenfrei Informationen** zu tierbezogenen Themen zur Verfügung. Es besteht **kein Anspruch auf Verfügbarkeit, Richtigkeit oder Vollständigkeit** der Inhalte.

## 3. Nutzung  
Die Nutzung der Webseite ist **jedermann gestattet**. Es ist nicht möglich, eigene Inhalte hochzuladen oder zu veröffentlichen.

## 4. Haftung  
Wir übernehmen **keine Haftung** für die Richtigkeit, Vollständigkeit oder Aktualität der bereitgestellten Inhalte. Ebenso schließen wir jede Haftung für technische Störungen oder Ausfälle der Webseite aus.

## 5. Änderung der Inhalte  
Wir behalten uns vor, Inhalte jederzeit zu ändern, zu ergänzen oder zu entfernen, ohne dies gesondert anzukündigen.

## 6. Rechtsordnung  
Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist, soweit zulässig, der Sitz der Esther Ratsch und Jörg Schultz GbR.
---

**Stand: April 2025**    
`;

const AGB_en = `
# Terms of Service

## 1. Scope  
This website is operated by **Esther Ratsch and Jörg Schultz GbR** and is intended for all interested users.

## 2. Services Provided  
The website offers **free informational content** on animal-related topics. There is **no guarantee** for the availability, accuracy, or completeness of the content.

## 3. Usage  
The website is **open to all users**. It is not possible to upload or publish user-generated content.

## 4. Liability  
We accept **no liability** for the correctness, completeness, or timeliness of the information provided. We also disclaim any liability for technical errors or downtime of the website.

## 5. Changes to Content  
We reserve the right to modify, supplement, or remove content on this website at any time without prior notice.

## 6. Legal Jurisdiction  
German law shall apply. The place of jurisdiction, to the extent permitted by law, is the registered office of Esther Ratsch and Jörg Schultz GbR.
---

**Effective Date: April 2025**  
    `;


export const AGB = {"de": AGB_de, "en": AGB_en};